/**
 * 班级管理 API
 */
import { request, buildUrl } from './request'

/**
 * 获取班级列表（支持筛选、分页）
 * @param {object} params - { class_name?, grade_id?, grade?, grade_name?, page?, page_size? }
 */
export function getClasses(params = {}) {
  const url = buildUrl('/api/classes', {
    class_name: params.class_name,
    grade_id: params.grade_id,
    grade: params.grade,
    grade_name: params.grade_name,
    page: params.page ?? 1,
    page_size: params.page_size ?? 10
  })
  return request(url)
}

/**
 * 根据 ID 获取班级
 * @param {number|string} id - 班级 ID
 */
export function getClass(id) {
  return request(`/api/classes/${id}`)
}

/**
 * 创建班级
 * @param {object} data - { device_id?, class_name, grade, head_teacher_id?, file_path?, create_by? }
 */
export function createClass(data) {
  return request('/api/classes', {
    method: 'POST',
    body: JSON.stringify(data)
  })
}

/**
 * 更新班级
 * @param {number|string} id - 班级 ID
 * @param {object} data - 更新数据
 */
export function updateClass(id, data) {
  return request(`/api/classes/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data)
  })
}

/**
 * 删除班级
 * @param {number|string} id - 班级 ID
 */
export function deleteClass(id) {
  return request(`/api/classes/${id}`, {
    method: 'DELETE'
  })
}
